import { render } from "./BaseRow.vue?vue&type=template&id=9036ae76&scoped=true"
import script from "./BaseRow.vue?vue&type=script&lang=js"
export * from "./BaseRow.vue?vue&type=script&lang=js"

import "./BaseRow.vue?vue&type=style&index=0&id=9036ae76&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9036ae76"]])

export default __exports__